var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetsTalkShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1298,
    height: 247,
    viewBox: "0 0 1298 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.4248,
    y: 3.43896,
    width: 1291.15,
    height: 361.015,
    rx: 44.5,
    stroke: "url(#paint0_radial_526_1520)",
    strokeWidth: 5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_526_1520",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-89.6585 127.608) rotate(-0.14414) scale(1756.44 495.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2F5FE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9907,
    stopColor: "#A6FA04"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetsTalkShadow);
export default __webpack_public_path__ + "static/media/letsTalk-shadow.9db72c400a7bcdc0baf1c9e59628f35a.svg";
export { ForwardRef as ReactComponent };